const normalizeContentType = (contentType?: string) =>
  contentType?.toLowerCase();

export const isAudioContentType = (contentType?: string) =>
  normalizeContentType(contentType)?.startsWith("audio/");

export const isVideoContentType = (contentType?: string) =>
  normalizeContentType(contentType)?.startsWith("video/");
